<!-- REFORMULAR -->

<template>
  <div class="not-found view">
    <base-card class="not-found-base-card">
			<div class="row mb-3 px-3 flex-row flex-wrap space-around">
				<h2 class="text-cart">Oops... :(</h2>
      </div>
      <div class="row mb-3 px-3 flex-row flex-wrap space-around">
				Permissão de acesso negada, por favor, certique-se de que sua chave de acesso está correta.
      </div>
    </base-card>
  </div>
</template>

<script>
export default {
	name: 'AccessDenied',
  beforeMount() {
    this.$swal.fire({
      icon: 'error',
      title: 'Ops...',
      text: 'Permissão de acesso negada, configuração não cadastrada no sistema!',
    });
  },
};
</script>